import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useTitle } from 'react-use';

import { SettingsPage } from '@/components/templates/SettingsPage/SettingsPage';
import { getPermissions } from '@/redux/permissions/selectors';
import useSegments from '@/segment/useSegments';
import { actions } from '@/shared/types/permissions';
import { PageName } from '@/shared/types/segment';
import { RootState } from '@/shared/types/state';

import { AccountSettingsSection } from './sections/AccountSettingsSection';

export const AccountSettings = () => {
  const { t } = useTranslation();

  useTitle(t('common.general'));

  const canUpdate = useSelector((state: RootState) =>
    getPermissions(state, 'accounts', actions.UPDATE)
  );

  useSegments(PageName.ACCOUNT_SETTINGS);

  return (
    <SettingsPage>
      <AccountSettingsSection readOnly={!canUpdate} />
    </SettingsPage>
  );
};
